/** La scheda Rilascio dell'interfaccia: percorso blue/green, controlli, instradamenti, CI. */
export const rilascioUi = {
  "ci.titolo": "Automazione",
  "ci.intro":
    "Un indirizzo segreto che, chiamato con un tag, salva una revisione con quel tag e avvia lo stack. " +
    "Serve a far partire il rilascio dalla pipeline che ha appena costruito l'immagine, senza dare a nessuno le credenziali di Portman.",
  "ci.copiaOra": "Copia ora questo comando: il token non sarà più mostrato.",
  "ci.conservaSegreto": "Nella CI conserva il token come segreto e sostituisci il tag con quello appena costruito.",
  "ci.attivo": "attivo",
  "ci.token": (p: { indizio: string }) => `token ${p.indizio}…`,
  "ci.usatoDiRecente": "usato di recente",
  "ci.maiUsato": "mai usato",
  "ci.variabileTag": (p: { variabile: string }) =>
    `Il tag ricevuto finisce nella variabile ${p.variabile}, che il compose usa per scegliere la versione dell'immagine. ` +
    "L'indirizzo non è più mostrabile: se è andato perso, rigeneralo — quello vecchio smette di funzionare.",
  "ci.rigenera": "Rigenera",
  "ci.revoca": "Revoca",
  "ci.genera": "Genera token",
  "ci.ultimeChiamate": "Ultime chiamate",
  "ci.accettata": "accettata",
  "ci.rifiutata": "rifiutata",

  "porteHost.correggi": "Correggi",
  "porteHost.rimosse": "Queste righe verranno rimosse:",
  "porteHost.aMano": (p: { servizi: string }) => `Restano da correggere a mano: ${p.servizi}.`,
  "porteHost.nulla": "Non c'è nulla che io possa togliere da solo.",
  "porteHost.revisione": "Nasce una revisione nuova: dallo storico puoi tornare a quella di adesso.",
  "porteHost.rimuovi": "Rimuovi e salva",

  "rilascioUi.tornaRicreazione": "Torna alla ricreazione",
  "rilascioUi.passaBlueGreen": "Passa a blue/green",
  "rilascioUi.sezione.controlli": "Controlli",
  "rilascioUi.sezione.strategia": "Strategia",
  "rilascioUi.sezione.instradamenti": "Instradamenti",
  "rilascioUi.sezione.automazione": "Automazione",
  "rilascioUi.titolo": "Rilascio senza interruzione",
  "rilascioUi.intro":
    "La versione nuova parte accanto a quella attiva; il traffico si sposta solo quando la nuova risponde. " +
    "Se qualcosa va storto prima dello spostamento, il traffico non si è mai mosso.",
  "rilascioUi.passo": (p: { k: number; n: number }) => `passo ${p.k} di ${p.n}`,
  "rilascioUi.attivo": "✓ Blue/green attivo: il prossimo rilascio non interrompe il servizio",
  "rilascioUi.compatibile": (p: { n: number }) =>
    `✓ Il compose è compatibile (${p.n} ${p.n === 1 ? "controllo superato" : "controlli superati"})`,
  "rilascioUi.apriConfigurazione": "Apri la configurazione",
  "rilascioUi.controlli.titolo": "Controlli prima dell'avvio",
  "rilascioUi.controlli.intro":
    "Mette alla prova l'ultima revisione salvata come farà l'avvio: variabili, immagini, porte e nomi dei container.",
  "rilascioUi.instradamenti.titolo": "Instradamenti",
  "rilascioUi.instradamenti.intro":
    "Il dominio di ogni servizio: Nginx Proxy Manager vi indirizza il traffico, e in un rilascio blue/green " +
    "lo sposta sulla versione nuova quando risponde.",

  "percorso.strategia.titolo": "Scegli la strategia blue/green",
  "percorso.strategia.perche": "Con la ricreazione i container si fermano prima che partano i nuovi.",
  "percorso.proxy.titolo": "Collega Nginx Proxy Manager",
  "percorso.proxy.perche": "È lui a spostare il traffico dalla versione attiva alla nuova.",
  "percorso.instradamento.titolo": "Associa un dominio a un servizio",
  "percorso.instradamento.perche": "È l'indirizzo che resta fisso mentre le versioni si scambiano.",
  "percorso.porte.titolo": "Togli le porte host",
  "percorso.porte.perche": "Due versioni accese insieme non possono occupare la stessa porta.",
  "percorso.nomi.titolo": "Togli i nomi fissi dei container",
  "percorso.nomi.perche": "Due versioni accese insieme non possono avere lo stesso nome di container.",
  "percorso.fissi-dominio.titolo": "Togli il dominio ai servizi fissi",
  "percorso.fissi-dominio.perche": "Un servizio fisso non cambia versione, quindi non c'è traffico da spostare.",
  "percorso.fissi-dipendenze.titolo": "Rendi fisse anche le dipendenze dei servizi fissi",
  "percorso.fissi-dipendenze.perche": "Un servizio fisso non può dipendere da uno che cambia a ogni rilascio.",
  "percorso.reti-nome.titolo": "Togli il nome fisso alle reti delle applicazioni",
  "percorso.reti-nome.perche": "Una rete con nome fisso unirebbe le due versioni.",
  "percorso.fissi-dati.titolo": "Sposta i dati dei servizi fissi",
  "percorso.fissi-dati.perche": "Un servizio diventato fisso nascerebbe vuoto, senza i dati della versione attiva.",

  "rilascioUi.fissi": "Restano fissi: ricreati solo se cambia la loro configurazione",
  "rilascioUi.fisso": "fisso",
  "rilascioUi.instradato": "instradato",
  "rilascioUi.portaDaIndicare": "porta interna da indicare",
  "rilascioUi.portaInterna": (p: { porta: number }) => `porta interna ${p.porta}`,
  "rilascioUi.piuPorte": "(ne dichiara più d'una)",
  "rilascioUi.nonNelCompose": "non più nel compose",
  "rilascioUi.modifica": "Modifica",
  "rilascioUi.instrada": "Instrada",
  "rilascioUi.rimuovi": "Rimuovi",
  "rilascioUi.dominio": "Dominio",
  "rilascioUi.portaInternaCampo": "Porta interna",
  "rilascioUi.dominioAiuto":
    "Il proxy lo legge dalla richiesta, non lo risolve: deve risolvere per chi apre il browser. " +
    "In locale nome.localhost funziona senza configurare nulla. Se l'applicazione costruisce i propri collegamenti " +
    "da una variabile — APP_URL e simili — usa quel dominio, o le chiamate successive alla prima pagina andranno altrove.",

  "proxy.installaNpm": "Installa Nginx Proxy Manager",
  "proxy.portaHttp": "Porta HTTP",
  "proxy.portaHttps": "Porta HTTPS",
  "proxy.porteAiuto":
    "Porte dell'host su cui il proxy riceve il traffico. Il pannello resta su 127.0.0.1:81, con le credenziali nell'environment dello stack.",
  "proxy.installa": "Installa",
};
